import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	validationMessageBeforeGreaterThanAfter: {
		id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
		defaultMessage: 'Specify a valid time range.',
		description:
			'Message displayed to the user when the Before date used is greater than the after date while specifying dates',
	},
	validationMessageInvalidDateFormat: {
		id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
		defaultMessage: 'Invalid date format.',
		description: 'Invalid date format.',
	},
	validationMessageAtLeastOneValue: {
		id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
		defaultMessage: 'Select at least one value.',
		description:
			'Message displayed to the user when there is no selected before and end date together',
	},
});

export default messages;
